import { useDailyOverview } from './useDailyOverview'
import { useMine } from './useMine'

export const overview = {
  mine: useMine,
  dailyOverview: useDailyOverview,
}
